import gql from 'graphql-tag'

export const GET_SYSTEM_PROMPT = gql`
  query GetSystemPrompt {
    getSystemPrompt {
      id
      name
      content
      version
      scope
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
  }
`

export const UPDATE_SYSTEM_PROMPT = gql`
  mutation UpdateSystemPrompt($data: UpdateSystemPromptInput!) {
    updateSystemPrompt(data: $data) {
      id
      name
      content
      version
      scope
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
  }
`

export const GET_PROJECTS = gql`
  query GetProjects {
    getProjects {
      _id
      name
    }
  }
`

export const GET_PROJECT_PROMPT = gql`
  query GetProjectPrompt($projectId: ID!) {
    getProjectPrompt(projectId: $projectId) {
      id
      content
      version
    }
  }
`

export const CREATE_PROJECT_PROMPT = gql`
  mutation CreateProjectPrompt($data: ProjectPromptInput!) {
    createProjectPrompt(data: $data) {
      id
      content
      version
    }
  }
`

export const UPDATE_PROJECT_PROMPT = gql`
  mutation UpdateProjectPrompt($data: UpdateProjectPromptInput!) {
    updateProjectPrompt(data: $data) {
      id
      content
      version
    }
  }
`
